import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef,} from '@angular/core';
import { FormControl } from '@angular/forms';
import { BehaviorSubject, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

export type Column = {
  name: string;
  field?: string;
  order?: 1 | -1 | null;
  mask?: string;
  date?: boolean | string;
  boolean?: {
    trueAlias: string;
    falseAlias: string;
  };
  styleInfo?:string
};

@Component({
  selector: 'app-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class GridComponent implements OnInit, OnChanges {
  @Input() public columns: Column[] = [];
  @Input() public draggable: boolean = false;
  @Input() public sortable: boolean = true;
  @Input() public data: any[] = [];
  @Input() public pageSize: number = 10;
  @Input() public btnLabel: string = null;
  @Input() public showBar: boolean = true
  @Input() public optionsTemplate: TemplateRef<any> = null;
  @Output() public btnClick: EventEmitter<void> = new EventEmitter<void>();
  @Output() public onDrag: EventEmitter<any[]> = new EventEmitter<any[]>();
  page: number = 1;
  total: number = 20;
  public filteredData$: Subject<any[]> = new Subject<any[]>();
  searchControl: FormControl = new FormControl();

  constructor() {}


  ngOnInit(): void {
    this.searchControl.valueChanges
      .pipe(distinctUntilChanged(), debounceTime(500))
      .subscribe(() => this.updateFilters());
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data) {
      this.updateFilters();
    }
  }

  updateFilters() {
    let data = this.data;

    if (this.searchControl.value) {
      data = this.data.filter(
        (value) =>
          JSON.stringify(value)
            .toLowerCase()
            .indexOf(this.searchControl.value.toLowerCase()) !== -1
      );
    }

    const column = this.columns.find((x) => x.order);
    if (column) {
      data.sort((a, b) => {
        if (!a[column.field]) a[column.field] = '';
        if (!b[column.field]) b[column.field] = '';
        if (
          typeof a[column.field] == 'string' &&
          typeof b[column.field] == 'string'
        ) {
          if (a[column.field].toLowerCase() > b[column.field].toLowerCase())
            return column.order;
          else
            return -column.order;
        } else {
          if (a[column.field] > b[column.field]) return column.order;
          else return -column.order;
        }
      });
    }
    this.clearPagination();

    this.filteredData$.next(data);
  }

  clearPagination($event?) {
    this.page = 1;
  }

  sort(column: Column) {
    this.columns.filter((x) => x !== column).forEach((x) => (x.order = null));
    column.order = column.order === 1 ? -1 : 1;
    this.updateFilters();
  }
}
